import React from "react";
import { string } from "prop-types";
import * as style from "./styles.module.scss";

const Resource = ({ title, description, link, cta }) => (
  <div className={style.resource__wrapper}>
    <h4 className={style.resource__title}>{title}</h4>
    <p className={style.resource__description}>
      <b>{description}</b>
    </p>
    <span className="d-flex justify-content-end">
      <a
        target="_blank"
        rel="noopener noreferrer"
        className={`btn btn-block btn-primary ${style.resource__button}`}
        href={link}
      >
        {cta}
      </a>
    </span>
  </div>
);

Resource.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  link: string,
  cta: string,
};

export default Resource;
